import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Container,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Typography,
    Paper,
    TablePagination,
} from '@mui/material';
import MathRenderer from '../components/MathRenderer';
import { supabase } from '../lib/supabase';

function HomePage() {
    const [problems, setProblems] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        async function fetchProblems() {
            const start = page * rowsPerPage;
            const end = start + rowsPerPage - 1;

            const { data, error } = await supabase
                .from('problems')
                .select('*', { count: 'exact' }) // Fetch total count for pagination
                .range(start, end); // Fetch only the rows for the current page

            if (error) {
                console.error('Error fetching problems:', error);
            } else {
                setProblems(data);
            }
        }

        fetchProblems();
    }, [page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = async (problemId) => {
        if (window.confirm('Are you sure you want to delete this problem? This action cannot be undone.')) {
            try {
                const { error } = await supabase
                    .from('problems')
                    .delete()
                    .eq('id', problemId);

                if (error) {
                    console.error('Error deleting problem:', error);
                    alert('Error deleting problem. Please try again.');
                } else {
                    // Remove the deleted problem from the state
                    setProblems(problems.filter(problem => problem.id !== problemId));
                }
            } catch (error) {
                console.error('Error deleting problem:', error);
                alert('Error deleting problem. Please try again.');
            }
        }
    };

    return (
        <Container sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>
                Problems
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button variant="contained" component={Link} to="/problems/new">
                    Add New Problem
                </Button>
            </Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Problem</TableCell>
                            <TableCell align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {problems.map((problem) => (
                            <TableRow key={problem.id}>
                                <TableCell>
                                    <Box sx={{ fontSize: '1rem' }}>
                                        <MathRenderer formula={problem.content} />
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            component={Link}
                                            to={`/problems/${problem.id}`}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            component={Link}
                                            to={`/problems/view/${problem.id}`}
                                        >
                                            View
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color="error"
                                            onClick={() => handleDelete(problem.id)}
                                        >
                                            Delete
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={problems.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </Container>
    );
}

export default HomePage;